"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function Form(_a) {
    var user = _a.user, setUser = _a.setUser, activeUser = _a.activeUser, _b = _a.channel, channel = _b === void 0 ? {} : _b;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Title, null, "Gegevens"),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { name: 'name', value: user.data.name, placeholder: 'Naam', onChange: function (name) { return setUser({ name: name }); } })),
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Input, { name: 'email', value: user.data.email, placeholder: 'E-mailadres', onChange: function (email) { return setUser({ email: email }); } })),
        !user.submitting &&
            user.data.id !== activeUser.id &&
            react_1.default.createElement(storybook_1.Users.FormChannels, { user: user.data, setUser: setUser, activeUser: activeUser, channel: channel }),
        !user.submitting &&
            activeUser.is_admin &&
            user.data.id &&
            user.data.id !== activeUser.id &&
            react_1.default.createElement(storybook_1.Users.Channels, { user: user.data }));
}
exports.default = Form;
Form.propTypes = {
    /**
     * The Video
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number,
        email: prop_types_1.default.string,
        channels: prop_types_1.default.array,
    }),
    /**
     * Set the Video
     */
    setUser: prop_types_1.default.func,
};
Form.defaultProps = {};
